import React, { useEffect } from "react";
import { Route, withRouter, useHistory } from "react-router-dom";
import Tab from "../../../../../Util/Tabs/Tab";
import Lead from "./Lead/Lead";
import "./Leads.css";
import { motion } from 'framer-motion';
import { pageTransitions, transitionDuration } from '../../../../../Util/PageTransitions';
function Leads(props) {
  const history = useHistory();
  const tabs = [
    {
      name: 'Leads',
      url: ''
    },
  ];

  return (
    <>
      <motion.div className='outer-wrapper cs-leads-page' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>
        <div className="content-wrapper leagues-wrapper">
          <div className="heading-wrapper">
            <h2 className="heading">{'Leads'}</h2>
          </div>
          <Tab tabs={tabs} type="leads_module" />
          <Route path={`${props.match.path}`} exact>
            <Lead />
          </Route>
        </div>
      </motion.div>
    </>
  );
}

export default withRouter(Leads);
